module.exports = __webpack_public_path__ + "img/violet_027.4dec5bd6.png";